import "@babel/polyfill";
import React from 'react';
import './index.scss';
import App from './App';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import Provider  from '@react/react-spectrum/Provider';
import './i18n';
import {Provider as ReduxProvider} from 'react-redux';
//import configureStore from './stores/configureStore';
import store from './stores/store';

//const store = configureStore();
(function () {
    if ( typeof NodeList.prototype.forEach === "function" ) return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

ReactDOM.render((
    <Provider theme="light" scale="medium">
        <ReduxProvider store={store}>
            <App/>
        </ReduxProvider>
    </Provider>), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
